import React from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import IFilter from "models/IFilter";
import Input from "components/Input";
import Select from "components/Select";
import DetailView from "components/DetailView";
import RangeDatepicker from "components/RangeDatepicker";
import ToggleSwitch from "components/ToggleSwitch";
import Button from "components/Button";
import FilterGenerator from "helpers/filter";
import withFilters from "helpers/withFilters";
import { CUSTOM_SETTINGS } from "constants/.";

class DeliverySearch extends React.Component<IFilter> {
  public static getInputQuery = (value) => {
    const Q = new FilterGenerator();

    if (value) {
      Q.and("DeliveryId", value);
      Q.or("OtherRelation/Name", value);
      Q.or("Lines", value, "array", "OrderLine/Order/Number");

      Q.addText(" or (");
      Q.without("Lines", value, "array", "Item/CultivarCode");
      Q.or("Lines", value, "array", "Item/Description");
      Q.addText(")");
    }

    return Q.query;
  };

  public static getFilterQuery = (f) => {
    const Q = new FilterGenerator();

    if (!_.isEmpty(f.documentDate)) {
      Q.and("Date", f.documentDate, "dateRange");
    }
    if (!_.isEmpty(f.deliveryEnd)) {
      Q.and("DeliveryDate", f.deliveryEnd, "dateRange");
    }
    Q.and("DeliveryId", f.notaNumber);
    Q.and("OtherRelation/Name", f.counterpartyName);
    Q.and("OtherRelation/Number", f.counterpartyNumber);
    Q.and("Seller/Name", f.sellerName);
    Q.and("Supplier/Name", f.supplierName);
    Q.and("RoleId", f.role, "select");
    Q.and("Bio", f.bio, "boolean");
    Q.and("Lines", f.orderNumber, "array", "OrderLine/Order/Number");

    if (f.description) {
      const checkQuery = Q.query ? true : false;
      checkQuery && Q.addText(" and (");
      Q.without("Lines", f.description, "array", "Item/CultivarCode");
      Q.or("Lines", f.description, "array", "Item/Description");
      checkQuery && Q.addText(")");
    }

    return Q.query;
  };

  public render() {
    const { filter, handleFilterChange, generateFilter, resetFilter, roleIds } =
      this.props;

    return (
      <DetailView
        pageName={CUSTOM_SETTINGS.deliveries}
        renderExpanded={() => (
          <div>
            <div className="filter-row">
              <Input
                label="GROWER"
                value={filter.sellerName}
                onChange={(e) =>
                  handleFilterChange(e.target.value, "sellerName")
                }
              />
              <div className="inner-block">
                <FormattedMessage id="PURCHASE_TYPE" tagName="label" />
                <Select
                  options={roleIds}
                  selectedOption={filter.role}
                  onChange={(value) => handleFilterChange(value, "role")}
                  className="min-width-select-forms"
                />
              </div>
            </div>
            <div className="filter-row">
              <Input
                label="PREFERRED_GROWER"
                value={filter.supplierName}
                onChange={(e) =>
                  handleFilterChange(e.target.value, "supplierName")
                }
              />
              <Input
                label="COUNTERPARTY_NUMBER"
                value={filter.counterpartyNumber}
                onChange={(e) =>
                  handleFilterChange(e.target.value, "counterpartyNumber")
                }
              />
            </div>
            <div className="filter-row">
              <RangeDatepicker
                name="documentDate"
                label="DOCUMENT_DATE"
                value={filter.documentDate}
                handleRangeChange={handleFilterChange}
              />
              <RangeDatepicker
                name="deliveryEnd"
                label="DELIVERIES_END_DATE"
                value={filter.deliveryEnd}
                handleRangeChange={handleFilterChange}
              />
            </div>
            <div className="filter-row">
              <ToggleSwitch
                label="DELIVERIES_BIO"
                on={filter.bio}
                onClick={() => handleFilterChange(!filter.bio, "bio")}
              />
            </div>
          </div>
        )}
      >
        <div className="filter-row">
          <Input
            label="DELIVERIES_NR"
            value={filter.notaNumber}
            onChange={(e) => handleFilterChange(e.target.value, "notaNumber")}
          />
          <Input
            label="COUNTERPARTY_NAME"
            value={filter.counterpartyName}
            onChange={(e) =>
              handleFilterChange(e.target.value, "counterpartyName")
            }
          />
        </div>
        <div className="filter-row">
          <Input
            label="ORDERS_NUMBER"
            value={filter.orderNumber}
            onChange={(e) => handleFilterChange(e.target.value, "orderNumber")}
          />
          <Input
            label="ARTICLE_DESCRIPTION"
            value={filter.description}
            onChange={(e) => handleFilterChange(e.target.value, "description")}
          />
        </div>
        <div className="search-btn">
          <Button onClick={resetFilter}>RESET</Button>
          <Button kind="primary" onClick={generateFilter}>
            SEARCH
          </Button>
        </div>
      </DetailView>
    );
  }
}

export default withFilters({
  placeholder: "DELIVERIES_SEARCH",
  pageName: CUSTOM_SETTINGS.deliveries,
})(DeliverySearch);
